module.exports = "<p>app-view works!</p>\n"